<template>
<svg viewBox="0 0 25 25" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-TaiDeng1`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.63378 3.89322C7.86084 3.00891 8.65795 2.39062 9.57094 2.39062H12.1862H14.8257C15.7273 2.39062 16.5175 2.99395 16.755 3.86376L19.0083 12.1151C19.1691 12.704 18.7677 13.298 18.1612 13.3683L18.0321 13.3833C17.7172 13.4198 17.4021 13.4534 17.0867 13.4839V15.7009C17.0867 16.1869 16.6927 16.5809 16.2067 16.5809C15.7206 16.5809 15.3267 16.1869 15.3267 15.7009V13.6231C14.5815 13.6688 13.8355 13.6978 13.0893 13.7102V21.2879H16.2868C16.7728 21.2879 17.1668 21.6818 17.1668 22.1679C17.1668 22.6539 16.7728 23.0479 16.2868 23.0479H12.2193C12.216 23.0479 12.2127 23.0479 12.2093 23.0479C12.206 23.0479 12.2027 23.0479 12.1994 23.0479H8.26281C7.7768 23.0479 7.38281 22.6539 7.38281 22.1679C7.38281 21.6818 7.7768 21.2879 8.26281 21.2879H11.3293V13.7084C9.6637 13.6775 7.99925 13.5634 6.34221 13.3663C5.75612 13.2966 5.36567 12.7265 5.51246 12.1548L7.63378 3.89322ZM9.07521 4.53249C9.12998 4.30874 9.33052 4.15137 9.56087 4.15137H12.2085H14.8577C15.0873 4.15137 15.2874 4.30776 15.3429 4.53058L17.0154 11.2489C17.0691 11.4647 16.9208 11.6794 16.7004 11.7085C13.7348 12.0995 10.7065 12.1015 7.74119 11.7079C7.52279 11.679 7.37785 11.4668 7.43024 11.2528L9.07521 4.53249Z"/></svg>
</template>
<script>

export default {
  name: 'IconTaiDeng1',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
